import React from "react";
import icon from "../../../assets/no-book-icon.png";
function NoBookingCard({
  text = "No bookings available to redeem!",
  paddingY = 5,
  marginY = 5,
}) {
  return (
    <div
      className={`d-flex align-items-center justify-content-center my-${marginY} py-${paddingY}`}
    >
      <div className="my-5 py-5">
        <div className="d-flex align-items-center justify-content-center"></div>
        <img className="mb-3 no-booking-img" src={icon} alt="empty" />
        <p className="m-0 cp-label">{text}</p>
      </div>
    </div>
  );
}

export default NoBookingCard;
